import { lazy } from 'react';

const CustomPlanificationsTemporalDistribution = lazy(() => import('./CustomPlanificationsTemporalDistribution'));

export default CustomPlanificationsTemporalDistribution;
